import { Paths } from "src/constants/paths";

export const getTermsAndConditions = (
  billingModel: string,
  url: string,
  category: string,
  numberOfMonths?: number,
  slug?: string,
) => {
  if (slug != null && ["iwl-ot", "wp-ot"].includes(slug)) {
    return [
      `payment-information.${billingModel}.${slug}.termsAndConditions.0`,
      `payment-information.${billingModel}.${slug}.termsAndConditions.1`,
      `payment-information.${billingModel}.${slug}.termsAndConditions.2`,
    ];
  }

  if (
    url.includes(Paths.ONE_TIME_PAYMENT_INFORMATION) &&
    category === "Weight Loss"
  ) {
    return [
      `payment-information.${billingModel}.${
        billingModel === "one_time" ? "" : `${numberOfMonths}month.`
      }termsAndConditions.0`,
      `payment-information.${billingModel}.${
        billingModel === "one_time" ? "" : `${numberOfMonths}month.`
      }termsAndConditions.1`,
    ];
  }

  return [
    `payment-information.${billingModel}.${
      billingModel === "one_time" ? "" : `${numberOfMonths}month.`
    }termsAndConditions.0`,
  ];
};
